import React from "react"

import ConfigurationContext from "../app/configuration-context";
// eslint-disable-next-line react/display-name
const withConfiguration = WrappedComponent => props => (
  <ConfigurationContext.Consumer>
    {(configuration) => (
      <WrappedComponent configuration={configuration} {...props}>
        {props.children}
      </WrappedComponent>
    )}
  </ConfigurationContext.Consumer>
);

export default withConfiguration;